import axios from 'axios'
import { API_URL } from '../api'

export const getTeamData = (teamId, callback) => {
	return dispatch => {
		axios.get(API_URL + '/teams/'+teamId)
			.then(response => {
                dispatch({
                    type: 'ENTITY_ADDED_OR_UPDATED',
                    payload: response.data,
                    entityType: 'team',
                })
			}).catch(error => {
				callback(error)
				console.log(error)
		})
	}
}

export const getCapacity = (teamId, callback) => {
	return dispatch => {
		axios.get(API_URL+'/teams/capacity/'+teamId)
			.then(response => {
				const {
					team,
					columns
				} = response.data

                dispatch({
                    type: 'ENTITY_ADDED_OR_UPDATED',
                    payload: team,
                    entityType: 'team',
				})
				
				if(callback){
					callback(columns)
				}
			}).catch(error => {
				console.log(error)
			})
	}
}

export const updateTeamOrder = ids => {
	return dispatch => {
		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: ids.map((id,index) => {
				return {
					id,
					order: index
				}
			}),
			entityType: 'team',
			isArray: true
		})
		
		axios.post(API_URL+'/teams/updateOrder', { ids })
	}
}

export const toggleCapacityInclusion = (team, account) => {
	return dispatch => {
		// teams_included_in_capacity
		const oldTeamsIncludedInCapacity = [...(account.teams_included_in_capacity || [])]
		const indexIfExists = oldTeamsIncludedInCapacity.indexOf(team.id)

		if(~indexIfExists){
			oldTeamsIncludedInCapacity.splice(indexIfExists, 1)
		}else{
			oldTeamsIncludedInCapacity.push(team.id)
		}

		axios.post(API_URL+'/teams/toggleCapacityInclusion', { 
			teamIds: oldTeamsIncludedInCapacity, 
			accountId: account
		})

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				...account,
				teams_included_in_capacity: oldTeamsIncludedInCapacity
			},
			entityType: 'account',
		})
	}
}


// WEBPACK FOOTER //
// ./src/state/actions/team-actions.jsx